<button *ngIf="this.config.showCloseButton" type="button" class="a3l-ui-dialog__close" (click)="close()">
  <a3l-ui-icon icon="cross"></a3l-ui-icon>
</button>

<ng-template cdkPortalOutlet></ng-template>

